const renderOfficial = (
  type: number,
  conditionNum: any,
  t: (key: string) => string,
  challengeName = '',
  item: any
): string => {
  switch (type) {
    // 可以做货，通知作者  需要做货，填写地址
    case 5:
      return `${t('appNotice.message_over')}${conditionNum}${t('appNotice.message_filling_it')}`
    // 可以做货，通知参与want it的用户
    case 6:
      return t('appNotice.message_grab_it')
    // 不可以做货，通知作者
    case 7:
      return '我们暂时无法生产您的设计产品。如果有疑问，请扫码添加客服微信咨询，获取具体说明及后续安排。感谢您的理解与支持！'
    // 不可以做货，通知所有参与用户
    case 8:
      return '我们的造物魔法无法将你想要的作品变为实物。不过别担心，我们已经退还了您的「想要」次数。我们会不断努力，期待在不久的将来为您带来惊喜!'
    // 进入生产流程
    case 9:
      return t('appNotice.message_work_was_made')
    // 活动中奖-做成实物奖励
    case 19:
      return `恭喜你！在${challengeName}活动中获奖（稍后可去活动页查看完整获奖公示），造好物将免费为您把这个作品做成实物！赶紧前往商店下单收货吧!`
    case 20:
      return `恭喜你！在${challengeName}活动中获奖！赶紧前往活动公示查看吧～ 联系造好物官方领取奖励`
    case 21:
      return `恭喜你！你的作品在${challengeName}活动中获奖啦 🎉（完整名单可前往活动页查看），你的创意受到了用户与官方的高度认可，感谢你的精彩创作！遗憾的是，经过工艺评估，我们暂时无法将该作品投入生产。对此我们深感抱歉，并已为你准备了专属补偿方案。请扫码添加客服微信，获取具体说明及后续安排。感谢你的理解与支持！`
    case 100:
      return item.payloadJson.content
    default:
      return ''
  }
}

export default renderOfficial
